// Constants
import { USER_NAVIGATE } from '../../../../../common/users/userConstants';

const searchPopupStayActivePredicate = (state, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
        case USER_NAVIGATE:
            return true;
        default:
            return false;
    }
};

export default searchPopupStayActivePredicate;
